const TourismSmartData = () => import('@/views/tourist/campaign/TourismSmartData')

const mainWidget = [
  {
    title: 'สัดส่วนหน่วยงานจากการลงทะเบียนเข้าร่วมงานแถลงข่าว Tourism Smart Data',
    path: '/admin/widget/:category/:widget_code(999)',
    component: TourismSmartData
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})